import { handlers as accountHandlers } from './account'
import { handlers as adresseHandlers } from './adresse'
import { handlers as diffusionHandlers } from './diffusion'
import { handlers as localiteHandlers } from './localite'
import { handlers as organisationHandlers } from './organisation'
import { handlers as produitOrganisationHandlers } from './produitOrganisation'
import { handlers as propertyHandlers } from './property'
import { hoqiRedecoHandler } from './server/hoqi'

export const handlers = [
  ...propertyHandlers,
  ...diffusionHandlers,
  ...localiteHandlers,
  ...adresseHandlers,
  ...organisationHandlers,
  ...produitOrganisationHandlers,
  ...accountHandlers,
  hoqiRedecoHandler(),
]
